module.exports = {"CLAIM_CHART_TITLE":"Claims by day/week/month/year","DAY":"day","WEEK":"week","MONTH":"month","YEAR":"year","CLAIM_CHART_TOOLTIP":"Number of claimes","SALES_CHART_TITLE":"Sales by day/week/month/year","SALES_CHART_TOOLTIP":"Number of sales"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/charts.json
// module id = 421
// module chunks = 8